import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { CreateAccountForm } from '../components/CreateAccountForm';
import { SessionService } from '../services/SessionService';
import { UpdatePasswordService } from '../services/UpdatePasswordService';
import sessionStore from '../stores/SessionStore';
import { CreateAccountFormFields } from '../types/CreateAccountFormFields';

export const CreateAccount: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [formData, setFormData] = useState<CreateAccountFormFields>({
    firstName: '',
    lastName: '',
    callSign: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [errors, setErrors] = useState<Record<string, string>>({});

  useEffect(() => {
    const searchEmail = searchParams.get('email') || '';
    setFormData((prevValues) => ({
      ...prevValues,
      email: searchEmail
    }));

    sessionStorage.setItem('token', searchParams.get('token') || '');
    sessionStorage.setItem('org', searchParams.get('org') || '');
  }, [location]);

  const createAccount = async () => {
    const token = sessionStorage.getItem('token') || '';
    const org = sessionStorage.getItem('org') || '';

    try {
      await UpdatePasswordService.updatePassword(formData, token);
      SessionService.login(formData.email, formData.password).then((resp) => {
        if (resp) {
          sessionStore.setUser(resp.data.user);
          sessionStore.setIsAuthenticated(true);
        }
      });

      navigate(`/organization-list?token=${token}&org=${org}`);
    } catch (error) {
      console.error('Error creating account:', error);
      toast.error(t('signup_page.errors.form_submission'));
    }
  };

  return (
    <CreateAccountForm
      buttonText={t('signup_page.create_account')}
      disableEmail
      errors={errors}
      formData={formData}
      onSubmit={createAccount}
      setErrors={setErrors}
      setFormData={setFormData}
    />
  );
};
